const style = (theme) => {
  const output = {
    root: {
      display: 'block',
      width: (props) => props.width,
      padding: 0,
      margin: 'auto',
      position: 'relative',
      top: 0,
      left: 0,
      boxSizing: 'border-box',
      zIndex: 10,
      clear: 'both',
      textAlign: (props) => props.alignTitle,
      fontFamily: theme.fonts[0],
      '&.extra $title': {
        marginTop: 0,
      },
      '&.big $title': {
        hyphens: 'auto',
      },
      '&.medium $title': {
      },
      '&.track $title': {
        WebkitTextFillColor: 'transparent',
        TextFillColor: 'transparent',
        MozTextStrokeColor: theme.getRgba(theme.colors[0], 1),
        WebkitTextStrokeColor: theme.getRgba(theme.colors[0], 1),
        MozTextStrokeWidth: '0.004em',
        WebkitTextStrokeWidth: '0.004em',
        WebkitFontSmoothing: 'antialiased',
      },
      '&.track.hover $title': {
        MozTextStrokeWidth: 0,
        WebkitTextStrokeWidth: 0,
        color: theme.colors[0],
        WebkitTextFillColor: theme.colors[0],
        // transition: '-webkit-text-fill-color .4s',
      },
      '&.trackIE $title': {
        WebkitTextFillColor: 'transparent',
        TextFillColor: 'transparent',
        MozTextStrokeColor: theme.getRgba(theme.colors[0], 1),
        WebkitTextStrokeColor: theme.getRgba(theme.colors[0], 1),
        MozTextStrokeWidth: '1px',
        WebkitTextStrokeWidth: '1px',
        WebkitFontSmoothing: 'antialiased',
      },
      '&.trackIE.hover $title': {
        MozTextStrokeWidth: 0,
        WebkitTextStrokeWidth: 0,
        color: theme.colors[0],
        WebkitTextFillColor: theme.colors[0],
      },
      '&.line $title': {
        paddingBottom: '1.8em',
        marginBottom: '1.8em',
        borderBottom: `1px solid ${theme.colors[0]}`,
      },
      '&.inline $title': {
        marginBottom: '0!important',
        minWidth: '20%',
      },
      '& a$subTitle:hover': {
        '&:before': {
          transform: 'scaleX(1)',
          transformOrigin: 'center left',
        },
      },
    },
    title: {
      extend: theme.typography.h1,
      lineHeight: 1.15,
      width: '100%',
      clear: 'both',
      position: 'relative',
      WebkitFontSmoothing: 'antialiased',
      fontWeight: 400,
      margin: 0,
      boxSizing: 'border-box',
      wordBreak: 'break-word',
      verticalAlign: 'middle',
      color: theme.colors[3],
      '& strong': {
        color: theme.colors[0],
        display: 'inline-block',
        position: 'relative',
        wordBreak: 'break-word',
        fontWeight: 400,
        // whiteSpace: 'nowrap',
      },
      '& > div': {
        // whiteSpace: 'nowrap',
        wordBreak: 'break-word',
        overflow: 'hidden',
        marginTop: '-0.2em',
        lineHeight: 1.35,
        fontWeight: 400,
      },
      '& div': {
        transformOrigin: 'bottom left',
        textIndent: 0,
      },
      '& > p > div': {
        overflow: 'hidden',
        lineHeight: 1.35,
        marginTop: '-0.2em',
      },
      '& div div': {
        transformOrigin: 'bottom left',
        textIndent: 0,
      },
    },
    preTitle: {
      extend: theme.typography.pretit,
      borderTop: `1px solid ${theme.colors[3]}`,
      paddingTop: 10,
      maxWidth: 480,
      width: '100%',
      position: 'relative',
      zIndex: 1,
      margin: 0,
      marginBottom: 30,
      color: theme.colors[3],
      textTransform: 'uppercase',
      fontSize: 10,
      '&:before': {
        content: '""',
        display: 'inline-block',
        marginRight: 8,
        width: 9,
        height: 9,
        borderRadius: '50%',
        background: theme.colors[3],
      },
      '&  div': {
        overflow: 'hidden',
      },
    },
    subTitle: {
      extend: theme.typography.pretit,
      textAlign: 'right',
      maxWidth: 480,
      width: '100%',
      top: 0,
      left: 0,
      paddingTop: 10,
      zIndex: 1,
      position: 'absolute',
      margin: 0,
      textDecoration: 'none',
      color: theme.colors[0],
      '&  div': {
        overflow: 'hidden',
      },
      '&:before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        height: 1,
        background: theme.colors[2],
        transform: 'scaleX(0)',
        transformOrigin: 'center right',
        transition: 'transform 0.8s cubic-bezier(0.19, 1, 0.22, 1)',
      },
    },
    paragraph: {
      width: '100%',
      clear: 'both',
      padding: 0,
      lineHeight: '1.4em',
    },
  }

  return output
}

export default style
